<style lang="scss" scoped>
.slide-17 {
  background-image: url("../../../assets/module5/slide17/bg-03.jpg");
  background-size: cover;
  background-position: center;
}
.heading1 {
  color: #ffffff;
  font-size: 42px;
  line-height: 50px;
}
.left {
  padding-left: 5%;
  padding-right: 2%;
  padding-top: 100px;
  p {
    width: 85%;
  }
}
.right {
  padding-left: 2%;
  padding-right: 5%;
}
p {
  color: white;
  margin-bottom: 36px;
}
.num {
  color: #c90c0f;
  font-size: 110px;
}
.num-wrap {
  display: flex;
  align-items: center;
  color: white;
  p {
    font-family: "Comfortaa-FAST";
    margin-bottom: 90px;
  }
  &.nw1 {
    transform: translateY(30px) translateX(-20px);
  }
  &.nw2 {
    transform: translateX(10px) translateY(-40px);
  }
  &.nw3 {
    transform: translate(-27px, -84px);
  }
  .desc {
    width: 177px;
    font-size: 25px;
    margin-bottom: 100px;
    .bt {
      font-size: 72px;
      line-height: 56px;
      margin-top: 15px;
      display: inline-block;
    }
    .c {
      color: #e73048;
    }
  }
}
.bnum {
  font-size: 380px;
}
h1 {
  font-size: 58px;
  color: #09509c;
  margin-bottom: 25px;
}
h2 {
  font-size: 58px;
}
.bub {
  z-index: 2;
}
</style>

<template>
  <div class="slide-17">
    <img src="@/assets/module5/slide17/face_img-03.png" class="chars bub" />

    <img src="@/assets/module5/slide17/arm_img-03.png" class="chars bub" />
    <img src="@/assets/module5/slide17/speech-03.png" class="chars bub" />

    <div class="flex">
      <div class="flex-1 left">
        <transition name="fadeUp" appear>
          <h1 v-show="slideIndex == 16">As FAST Hero 000 members,</h1>
        </transition>

        <transition name="fadeUp" appear>
          <p v-show="slideIndex == 16" class="delay-1">
            It’s very important that you remember what you might see if someone
            is having a stroke.
          </p>
        </transition>
        <transition name="fadeUp" appear>
          <p v-show="slideIndex == 16" class="delay-2">
            Here is a really easy way to remember what it looks like when the
            Evil Clot causes a stroke.
          </p>
        </transition>

        <transition name="fadeUp" appear>
          <h2 v-show="slideIndex == 16" class="delay-3">Just Remember 000!</h2>
        </transition>

        <transition name="fadeUp" appear>
          <img
            v-show="slideIndex == 16"
            src="@/assets/module5/slide17/img-03.png"
            class="chars delay-4"
          />
        </transition>
      </div>

      <div class="flex-1 right">
        <transition name="fadeRight" appear>
          <img
            v-show="slideIndex == 16"
            src="@/assets/module5/slide17/green_wave-03.png"
            class="chars wave delay-5"
          />
        </transition>
        <transition name="fadeRight" appear>
          <img
            v-show="slideIndex == 16"
            src="@/assets/module5/slide17/purple_wave-03.png"
            class="chars delay-6"
          />
        </transition>
        <transition name="fadeRight" appear>
          <img
            v-show="slideIndex == 16"
            src="@/assets/module5/slide17/red_wave-03.png"
            class="chars delay-7"
          />
        </transition>

        <transition name="scale" appear>
          <div v-show="slideIndex == 16" class="delay-6">
            <div class="num-wrap kooky nw1">
              <p>The first 1 is</p>
              <div class="bnum kooky">1</div>
              <div class="desc">
                IF SOMEONE’S
                <span class="bt">FACE</span> SUDDENLY DROOPS TO
                <span class="c">ONE</span>
                SIDE
              </div>
            </div>
          </div>
        </transition>

        <transition name="scale" appear>
          <div class="delay-7" v-show="slideIndex == 16">
            <div class="num-wrap kooky nw2">
              <p>The next 1 is</p>
              <div class="bnum kooky">1</div>
              <div class="desc">
                IF SOMEONE SUDDENLY
                <br />LOSES <br />POWER <br />IN
                <span class="c">ONE</span>
                <span class="bt">ARM</span>
              </div>
            </div>
          </div>
        </transition>

        <transition name="scale" appear>
          <div class="delay-8" v-show="slideIndex == 16">
            <div class="num-wrap kooky delay-7 nw3">
              <p>And 2 is for</p>
              <div class="bnum kooky">2</div>
              <div class="desc">
                IF
                <span class="c">TWO</span> INCOHERENT LIPS SUDDENLY AFFECT THEIR
                <span class="bt">SPEECH</span>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
